import * as React from 'react';
import { autorun } from 'mobx';
const usePositionLock = (map, positionWatcher) => {
    const [positionLock, setPositionLock] = React.useState(false);
    React.useEffect(() => {
        if (!map || !positionWatcher)
            return;
        if (positionLock) {
            const disposer = autorun(() => {
                const p = positionWatcher.position;
                if (p) {
                    map.panTo([p.coords.longitude, p.coords.latitude]);
                }
            });
            map.once('dragstart', () => {
                setPositionLock(false);
            });
            return () => {
                disposer();
            };
        }
    }, [map, positionWatcher, positionLock]);
    return [positionLock, setPositionLock];
};
export default usePositionLock;
